const KEY = "cookie-consent-v1";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const saveConsent = (external) => {
  localStorage.setItem(
    KEY,
    JSON.stringify({ necessary: true, external: Boolean(external), ts: Date.now() })
  );
  window.dispatchEvent(new CustomEvent("consent-changed"));
};

export const openCookieSettings = () => {
  window.dispatchEvent(new CustomEvent("open-cookie-settings"));
};
